"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBoxShadows = exports.CardSizes = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_custom_scrollbars_1 = require("react-custom-scrollbars");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
var CardSizes;
(function (CardSizes) {
    CardSizes["Small"] = "small";
    CardSizes["Medium"] = "medium";
})(CardSizes || (exports.CardSizes = CardSizes = {}));
var CardBoxShadows;
(function (CardBoxShadows) {
    CardBoxShadows["Default"] = "default";
    CardBoxShadows["OverlayBlockShadow"] = "overlayBlockShadow";
})(CardBoxShadows || (exports.CardBoxShadows = CardBoxShadows = {}));
const renderView = ({ style }) => (0, jsx_runtime_1.jsx)("div", { style: style, className: styles_module_css_1.default.scroller });
const Card = react_1.default.forwardRef(({ children, footer, header, size = CardSizes.Medium, scroll = false, lonely = false, boxShadow = CardBoxShadows.Default, themable = true, ...props }, ref) => ((0, jsx_runtime_1.jsxs)("div", { ref: ref, className: (0, classnames_1.default)(styles_module_css_1.default.card, styles_module_css_1.default[size], {
        [styles_module_css_1.default[`card_${boxShadow}`]]: Boolean(boxShadow),
        [styles_module_css_1.default.scroll]: scroll,
        [styles_module_css_1.default.lonely]: lonely,
        [styles_module_css_1.default.themable]: themable,
        [styles_module_css_1.default.white]: !themable,
    }), ...props, children: [header && (0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.header, children: header }), (0, jsx_runtime_1.jsx)("div", { "qa-element": "card-body", className: (0, classnames_1.default)(styles_module_css_1.default.body, {
                [styles_module_css_1.default.scroll]: scroll,
                [styles_module_css_1.default.hasFooter]: !!footer,
                [styles_module_css_1.default.hasHeader]: !!header,
            }), children: scroll ? ((0, jsx_runtime_1.jsx)(react_custom_scrollbars_1.Scrollbars, { renderView: renderView, children: children })) : (children) }), footer && (0, jsx_runtime_1.jsx)("div", { className: styles_module_css_1.default.footer, children: footer })] })));
exports.default = Card;
